import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FarmService} from '@services/farm.service';

@Component({
    selector: 'app-add-farmhouse-partition',
    templateUrl: './add-farmhouse-partition.component.html',
    styleUrl: './add-farmhouse-partition.component.scss'
})
export class AddFarmhousePartitionComponent implements OnInit {
    // SENSORS - HIDE UI
    // public availableSensors: any[] = [];
    @Input() partitionFormGroup: FormGroup;
    @Input() index: number;
    @Output() removeFarmHousePartitionEvent = new EventEmitter<number>();
    constructor(private farmService: FarmService) {}
    ngOnInit(): void {
        // SENSORS - HIDE UI
        // this.fetchAvailableSensors();
    }

    // SENSORS - HIDE UI
    // fetchAvailableSensors() {
    //   this.farmService.getSensorsList().subscribe(
    //     result => {
    //       this.availableSensors = result;
    //     }
    //   );
    // }
    removeFarmHousePartition(): void {
        this.removeFarmHousePartitionEvent.emit(this.index);
    }
    isControlInvalid(controlName: string): boolean {
        const control = this.partitionFormGroup.get(controlName);
        return control?.invalid && (control.touched || control.dirty);
    }
}
